<ng-container matColumnDef="phone_input">
  <form #f="ngForm" [formGroup]="phoneForm" [attr.autocomplete]="disableBrowserAutofill ? 'off' : null" [attr.data-lpignore]="disableBrowserAutofill ? 'true' : null" [attr.data-form-type]="disableBrowserAutofill ? 'other' : null">
    <div class="wrapper phone-field mb-4">
      <div
        class="mat-like-field mat-like-outline always-float-label full-width mb-0"
        [class.has-value]="!!phoneForm.get('phone')?.value"
        [class.disabled]="phoneForm.get('phone')?.disabled"
        [class.invalid]="phoneForm.get('phone')?.invalid && (phoneForm.get('phone')?.touched || phoneForm.get('phone')?.dirty)">
        <label class="mat-like-label" *ngIf="labelInput && labelInput != ''">{{ isRequired ? labelInput + '*' : labelInput }}</label>
        <ngx-intl-tel-input
          [cssClass]="inputClass"
          [preferredCountries]="preferredCountries"
          [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true"
          [searchCountryFlag]="true"
          [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
          [selectFirstCountry]="false"
          [selectedCountryISO]="selectedCountry"
          [maxLength]="mobileMaxLength"
          [phoneValidation]="true"
          [separateDialCode]="separateDialCode"
          [inputId]="idInput"
          (countryChange)="onChange($event)"
          #phoneInput
          name="phone"
          formControlName="phone">
        </ngx-intl-tel-input>
      </div>
      <div class="px-3">
        <ng-container *ngIf="hintInput && hintInput != ''">
          <div class="mat-like-hint" *ngIf="!(phoneForm.get('phone')?.invalid && (phoneForm.get('phone')?.touched || phoneForm.get('phone')?.dirty))">
            {{ hintInput }}
          </div>
        </ng-container>
        <div class="mat-like-error" *ngIf="phoneForm.get('phone')?.invalid && (phoneForm.get('phone')?.touched || phoneForm.get('phone')?.dirty)">
          Please enter a valid phone number.
        </div>
      </div>
    </div>
  </form>
</ng-container>
